import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TransitEnterexitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"transit_enterexit"}/>
}
